<template>
    <div id="Pilotage">
        <div id="pilotalBar" class="setbanner">
            <div class="Pilotage_bj">
                <div class="setsail_padding">
                    <div class="setsail_biaoti">领航版</div>
                    <div class="setsail_text">
                        <p>是城市静态交通发展至成熟阶段，基本完成智慧停车建设，积累一定静态交</p>
                        <p class="text_padding">通数据后，围绕城市静态交通数据搭建实现的交互、表现、标准化采集的大</p>
                        <p class="text_padding">数据产品。</p>
                    </div>
                </div>
            </div>
            <div class="setsail_menu" :class="searchBarFixed == true ? 'isFixed' :''">
                <ul class="titlename_ul">
                    <li>
                        <span data-silde='1' :class="{active:showone}" @click="setsailone($event)">方案介绍</span>
                    </li>
                    <li>
                        <span data-silde='2' :class="{active:showtow}" @click="setsailtwo($event)">产品组成</span>
                    </li>
                    <li>
                        <span data-silde='3' :class="{active:showthrid}" @click="setsailth($event)">方案优势</span>
                    </li>
                    <li>
                        <span data-silde='4' :class="{active:showfor}" @click="setsailfor($event)">产品展示</span>
                    </li>
                </ul>
            </div>
        </div>
        <div id="setsailone">
            <div style="padding-bottom:96px;">
                <div class="setsail_jieshao">快速了解领航</div>
                <div class="tXy">
                    <div class="anniu" style="text-align:center;" @click="Img">
                        <div class="yun_shi"></div>
                    </div>
                </div>
            </div>
            <div class="setsail">
                <div class="setsail_jieshao">方案介绍</div>
                <div class="curauto">
                    <div class="setflex_div">
                        <div class="content_width">
                            <div class="setsail_bt">
                                领航
                            </div>
                            <div class="setsail_butflex">
                                <div class="setsail_jue">
                                    <div>大数据分析+可视化</div>
                                </div>
                                <div class="setsail_jue set_mar">
                                    <div>资源规划决策</div>
                                </div>
                                <div class="setsail_jue set_mar">
                                    <div>停车资源接入</div>
                                </div>
                            </div>
                            <div class="setright_text curight_text" style="width:392px;">
                                <div class="settext_div">"领航"是面向城市静态交通进入成熟阶段的大数据分析及其可视化产品。这个阶段城市已基本实现智慧停车建设，积累一定静态交通数据。领航系列为城市提供资源全景的顶级数据呈现，优化静态交通资源效率。</div>
                            </div>
                        </div>
                        <div class="setcuntry cursie_div">
                            <div class="settitle">适用城市</div>
                            <div class="setul_text">
                                <ul>
                                    <li>完成智慧停车建设，需求数据驱动资源优化的城市</li>
                                    <li>需求静态交通资源信息化、立体数据化呈现的城市</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Lhpro_div">
                <div class="setsail_jieshao">领航产品应用</div>
                <div class="setflex_plo">
                    <div class="pilotage_img">
                        <div class="pilogate_one"></div>
                        <div class="pilogate_text">全类型停车资源整合</div>
                    </div>
                    <div class="pilotage_img pilotage_mar">
                        <div class="pilogate_two"></div>
                        <div class="pilogate_text">静态交通大数据呈现与应用</div>
                    </div>
                    <div class="pilotage_img pilotage_mar">
                        <div class="pilogate_third"></div>
                        <div class="pilogate_text">静态交通资源规划决策</div>
                    </div>
                </div>
            </div>
        </div>
        <div id="setsailtwo" class="setsail_plo">
            <div class="setsailtwo_auto">
                <div class="programme">产品组成</div>
                <div class="setsail_plotext">领航系列产品以城市静态交通大脑为核心，通过接入城市静态交通资源、公共类停车资源、社会化停车资源的数据，统一汇集到交通大脑中，由静态交通大脑进行分析处理，然后再向公众服务中心、运行监控中心和数据领航中心三个方向输出。
                </div>
                <div class="setsail_plotext plotext_div">
                    通过建立多维度的数据分析模型，再用清晰直观的数据可视化平台呈现，辅助城市智慧停车的运营管理，对城市静态交通进行规划决策。
                </div>
                <div class="setsail_plobg"></div>
            </div>
            <div class="ploBg_color">
                <div class="ploBg_img">
                    <div class="ploBg_title">
                        <span>8大类</span>
                        <span class="ploBg_mar">22款产品</span>
                        <span class="ploBg_mar"> 500+项功能</span>
                    </div>
                    <div class="ploBgtitle_child">全面覆盖城市静态交通业务场景</div>
                    <div class="ploBg_flex">
                        <div class="ploBg_div">
                            <div class="ploBgimg"><img src="../../../common/img/Selove/Pilotage/lhsjlh.png" /></div>
                            <div class="ploBg_text">数据领航中心</div>
                            <div class="ploBgtext_content">提供多维度的数据分析模型，以数据为驱动，优化停车资源运营，辅助市政规化决策。深度挖掘静态交通的数据价值，沉淀城市数据资产</div>
                        </div>
                        <div class="ploBg_div ploBgdiv_mar">
                            <div class="ploBgimg"><img src="../../../common/img/Selove/Pilotage/lhsjjr.png" /></div>
                            <div class="ploBg_text">数据接入平台</div>
                            <div class="ploBgtext_content">通过接入社会及公共类停车资源，打破数据孤岛现状，形成城市静态交通资源的统一数据管理体系</div>
                        </div>
                        <div class="ploBg_div ploBgdiv_mar">
                            <div class="ploBgimg"><img src="../../../common/img/Selove/Pilotage/lhyigl.png" /></div>
                            <div class="ploBg_text">运营管理平台</div>
                            <div class="ploBgtext_content">为城市停车相关的各种业务提供全方位的运营服务支持，实现城市智慧停车统一运筹管理，实时掌控停车业务的运营情况，提升管理效率</div>
                        </div>
                    </div>
                    <div class="ploBg_Carflex">
                        <div class="ploBg_cardiv">
                            <div>
                                <img src="../../../common/img/Selove/Pilotage/lhlntc.jpg" />
                            </div>
                            <div class="ploBgcar_text">路内停车产品</div>
                            <div class="ploBgcar_content">面向路边停车的综合管理平台产品体系，支持地磁及视频全技术模式，打造路内泊位物联网脉络，涵盖路边停车的管理、收费、运营、服务的综合体系。</div>
                        </div>
                        <div class="ploBg_cardiv ploBgcar_mar">
                            <div><img src="../../../common/img/Selove/Pilotage/lhlwtc.jpg" /></div>
                            <div class="ploBgcar_text">路外停车场产品</div>
                            <div class="ploBgcar_content">搭建停车场车牌识别、车辆出入管理和停车费收取的综合管理体系，涵盖停车场综合管理系统、停车场收费系统、停车场商家优免平台等，实现停车场联网信息化管理</div>
                        </div>
                    </div>
                    <div class="ploBg_Carflex">
                        <div class="ploBg_new">
                            <div>
                                <img src="../../../common/img/Selove/Pilotage/lhxnycd.jpg" />
                            </div>
                            <div class="ploBgnew_text">新能源充电桩产品</div>
                            <div class="ploBgnew_content">基于车联网、移动互联网、大数据等技术的新能源汽车运营管理平台，实现对充电设施全网监控管理，对入网电动车辆管理、调度以及实施充电计划等。</div>
                        </div>
                        <div class="ploBg_new ploBgcar_mar">
                            <div>
                                <img src="../../../common/img/Selove/Pilotage/lhcstc.jpg" />
                            </div>
                            <div class="ploBgnew_text">城市停车诱导产品</div>
                            <div class="ploBgnew_content">基于城市停车资源的实时统计和发布平台，融合城市动静态交通数据，为市民形成完整停车诱导服务，能有效引导车主到达目的地、优化交通效率，提高停车设施利用率。</div>
                        </div>
                        <div class="ploBg_new ploBgcar_mar">
                            <div>
                                <img src="../../../common/img/Selove/Pilotage/lhgzfw.jpg" />
                            </div>
                            <div class="ploBgnew_text">公众服务产品</div>
                            <div class="ploBgnew_content">市民车主可通过手机APP、微信公众号、小程序等多种产品形态获得丰富的停车相关增值服务，提升车主的停车体验。</div>
                        </div>
                    </div>
                </div>
                <div class="crunameBg">
                    <div class="crusename_auto">
                        <div class="curBg_title">智能硬件连接城市</div>
                        <div class="curBg_content">统一的智能物联设备连接平台，采集城市静态交通数据</div>
                        <div class="curiseout_width">
                            <div class="curiseout_flex curisewidth_name">
                                <div class="YJ_bt">路内设备</div>
                                <div class="curiseout_flex">
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="dc_img"></div>
                                        </div>
                                        <div class="curise_text">地磁</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="wg_img"></div>
                                        </div>
                                        <div class="curise_text">网关</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="zjq_img"></div>
                                        </div>
                                        <div class="curise_text">中继器</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="rfid_img"></div>
                                        </div>
                                        <div class="curise_text">RFID</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="sp_img"></div>
                                        </div>
                                        <div class="curise_text">视频</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="pda_img"></div>
                                        </div>
                                        <div class="curise_text">PDA</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="curiseout_width">
                            <div class="curiseout_flex">
                                <div class="YJ_bt" style="height:268px;padding-top:104px;">路外设备</div>
                                <div class="curiseout_flex">
                                    <div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="zndz_img"></div>
                                            </div>
                                            <div class="curise_text">智能道闸</div>
                                        </div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="fxxc_img"></div>
                                            </div>
                                            <div class="curise_text">反向寻车机</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="sbxj_img"></div>
                                            </div>
                                            <div class="curise_text">识别相机</div>
                                        </div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="zdgl_img"></div>
                                            </div>
                                            <div class="curise_text">终端管理盒</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="fc_img"></div>
                                            </div>
                                            <div class="curise_text">蜂巢一体机</div>
                                        </div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="smzd_img"></div>
                                            </div>
                                            <div class="curise_text">扫码终端</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="ydp_img"></div>
                                            </div>
                                            <div class="curise_text">引导屏</div>
                                        </div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="znds_img"></div>
                                            </div>
                                            <div class="curise_text">智能地锁</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="rkxsq_img"></div>
                                            </div>
                                            <div class="curise_text">入口显示屏</div>
                                        </div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="jdq_img"></div>
                                            </div>
                                            <div class="curise_text">继电器</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="spjcq_img"></div>
                                            </div>
                                            <div class="curise_text">视频检测器</div>
                                        </div>
                                        <div class="curisewidth_div">
                                            <div class="curise_yuan">
                                                <div class="line_img"></div>
                                            </div>
                                            <div class="curise_text">网关</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="curiseout_width">
                            <div class="curiseout_flex curisewidth_name">
                                <div class="YJ_bt">新能源设备</div>
                                <div class="curiseout_flex">
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="jlcdz_img"></div>
                                        </div>
                                        <div class="curise_text">交流充电桩</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="zlcdz_img"></div>
                                        </div>
                                        <div class="curise_text">直流充电桩</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="ytcdz_img"></div>
                                        </div>
                                        <div class="curise_text">一体充电桩</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="curiseout_width">
                            <div class="curiseout_flex curisewidth_name">
                                <div class="YJ_bt">其他设备</div>
                                <div class="curiseout_flex">
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="yjydp_img"></div>
                                        </div>
                                        <div class="curise_text">一级诱导屏</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="ejydp_img"></div>
                                        </div>
                                        <div class="curise_text">二级诱导屏</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="sjydp_img"></div>
                                        </div>
                                        <div class="curise_text">三级诱导屏</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="hujiao_img"></div>
                                        </div>
                                        <div class="curise_text">呼叫中心</div>
                                    </div>
                                    <div class="curisewidth_div">
                                        <div class="curise_yuan">
                                            <div class="pinjie_img"></div>
                                        </div>
                                        <div class="curise_text">拼接大屏</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="setsailthird">
            <div class="setsail_jieshao">方案优势</div>
            <div class="ploBg_ysflex">
                <div class="ploBgflex_div">
                    <div class="ploBgflex_Img">
                        <img src="../../../common/img/Selove/Pilotage/lhfa_sj.png" />
                    </div>
                    <div class="ploBgflex">数据驱动城市静态交通发展</div>
                    <div class="ploBgflex_content">提供多维度数据分析模型，挖掘数据潜在价值，打造全面直观的数据可视化分析平台，为城市停车的精细化运营和城市资源规划提供支撑</div>
                </div>
                <div class="ploBgflex_div ploBgflex_mar">
                    <div class="ploBgflex_Img">
                        <img src="../../../common/img/Selove/Pilotage/lhfa_js.png" />
                    </div>
                    <div class="ploBgflex">覆盖全场景的前端技术兼容</div>
                    <div class="ploBgflex_content">兼容POS机、地磁、高位视频等多种技术模式，结合各类技术的优势，因地制宜，打造综合解决方案，实现路内停车收费管理稳定运行</div>
                </div>
                <div class="ploBgflex_div ploBgflex_mar">
                    <div class="ploBgflex_Img">
                        <img src="../../../common/img/Selove/Pilotage/lhfa_gk.png" />
                    </div>
                    <div class="ploBgflex">城市静态交通资源统一管控</div>
                    <div class="ploBgflex_content">全面整合自有和外部停车数据，打破停车业务和系统之间的信息壁垒，形成全市静态交通资源的统一管控</div>
                </div>
                <div class="ploBgflex_div ploBgflex_mar">
                    <div class="ploBgflex_Img">
                        <img src="../../../common/img/Selove/Pilotage/lhfa_kz.png" />
                    </div>
                    <div class="ploBgflex">支持多维度停车业务扩展</div>
                    <div class="ploBgflex_content">以路内+路外为核心，围绕城市停车资源，扩展延伸充电、立体车库、城市诱导、共享停车等服务，实现城市停车业务全覆盖</div>
                </div>
            </div>
        </div>
        <div id="setsailfou" class="crunameBg">
            <div class="setsail_jieshao" style="padding-bottom:16px;">产品展示</div>
            <div class="proImg"></div>
            <div class="ploBGflex">
                <div class="lastflex">
                    <div class="ployuan"></div>
                    <div class="ployuan_text">城市静态交通资源分布全景 </div>
                </div>
                <div class="lastflex lastflex_mar">
                    <div class="ployuan"></div>
                    <div class="ployuan_text">停车资源网格化管理与服务覆盖</div>
                </div>
                <div class="lastflex lastflex_mar">
                    <div class="ployuan"></div>
                    <div class="ployuan_text">智慧停车运营负荷热力图</div>
                </div>
                <div class="lastflex lastflex_mar">
                    <div class="ployuan"></div>
                    <div class="ployuan_text">城市静态交通资源动态计算</div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
@import '../../../common/css/progra';
@import 'pilotage';
</style>
<script>
import $ from 'jquery';
import videoPlayer from '@/components/video-player';
export default {
  data() {
    return {
      scroll: '',
      active: {
        background: '#eee',
      },
      searchBarFixed: false,
      showone: true,
      showtow: false,
      showthrid: false,
      showfor: false,
      sidle1: '',
      videlist: [],
      MIYao: '',
    };
  },
  //离开页面移除监听事件
  destroyed() {
    window.removeEventListener('scroll', this.menu);
  },
  mounted() {
    this.$nextTick(function() {
      //滚动监听事件
      window.addEventListener('scroll', this.menu);
    });
  },
  methods: {
    //操作顶部tab
    setsailone(e) {
      var sidle1 = $('#setsailone').offset().top;
      $('html,body').animate({ scrollTop: sidle1 }, 800);
      if (e.target.getAttribute('data-silde') == '1') {
        this.showone = true;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = false;
      }
    },
    setsailtwo(e) {
      var lastesth_sidle2 = $('#setsailtwo').offset().top;
      $('html,body').animate({ scrollTop: lastesth_sidle2 }, 800);
      if (e.target.getAttribute('data-silde') == '2') {
        this.showone = false;
        this.showtow = true;
        this.showthrid = false;
        this.showfor = false;
        this.showfive = false;
      }
    },
    setsailth(e) {
      var rank_sidle3 = $('#setsailthird').offset().top;
      $('html,body').animate({ scrollTop: rank_sidle3 }, 800);
      if (e.target.getAttribute('data-silde') == '3') {
        this.showone = false;
        this.showtow = false;
        this.showthrid = true;
        this.showfor = false;
      }
    },
    setsailfor(e) {
      var fourth_silde4 = $('#setsailfou').offset().top;
      $('html,body').animate({ scrollTop: fourth_silde4 }, 800);
      if (e.target.getAttribute('data-silde') == '4') {
        this.showone = false;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = true;
      }
    },
    //监听滚动的事件
    menu() {
      var _self = this;
      _self.scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var menuTop = document.querySelector('#pilotalBar').offsetTop;
      //滑动到指定位置菜单吸顶
      if (_self.scroll > menuTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
      //滑动到指定位置相应菜单高亮
      var sidle2 = $('#setsailtwo').offset().top;
      var sidle3 = $('#setsailthird').offset().top;
      var sidle4 = $('#setsailfou').offset().top;
      if (_self.scroll < sidle2) {
        this.showone = true;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = false;
      } else if (_self.scroll < sidle3) {
        this.showone = false;
        this.showtow = true;
        this.showthrid = false;
        this.showfor = false;
      } else if (_self.scroll < sidle4) {
        this.showone = false;
        this.showtow = false;
        this.showthrid = true;
        this.showfor = false;
      } else if (_self.scroll > sidle3) {
        this.showone = false;
        this.showtow = false;
        this.showthrid = false;
        this.showfor = true;
      }
    },
    Img() {
      videoPlayer({
        title: '领航版',
        width: '960',
        height: '494',
        videoSrc:
          'https://1253953386.vod2.myqcloud.com/vod-player/1253953386/5285890783637327356/tcplayer/console/vod-player.html?t=6d17af80&width=960&height=494&sign=ca636801fef462533beb3a2675c4944f',
      });
    },
  },
};
</script>

